// Round 5 (2026-09-10 §19-§23) — Global route scrollTop on PUSH nav only.
// Browser back/forward (POP) preserves scroll (§23 · browser default kept).
import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType(); // PUSH · REPLACE · POP
  useEffect(() => {
    if (navType !== 'POP') window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, navType]);
  return null;
};
export default ScrollToTop;
